import Header from '../../components/Common/Header';
import { RouteProps, Route } from 'react-router-dom';

export function MasterRouter(props: RouteProps) {
  return (
    <>
      <div className="wrapper">
        <div className={`article article-full`}>
          <div className="wrapper-content">
            <div className={`right-side`}>
              <div className="content">
                <Route {...props} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

